<template>
  <div class="flex" id="personal-information">
    <div class="flex column align-center justify-center aside">
      <img src="@/assets/images/iconPerson.svg" class="icon" alt="Error icon" />
      <p class="label">
        {{ cardTitle }}
      </p>
    </div>
    <div class="flex column justify-center information">
      <PersonalInformationRow
        :title="userNameLabel"
        v-model="name"
      />
      <PersonalInformationRow
        title="Correo"
        v-model="email"
      />
      <PersonalInformationRow
        title="Global Entry"
        v-if="userIsNormalType"
        v-model="sentri"
      />
    </div>
  </div>
</template>

<script>
import PersonalInformationRow from '@/components/Vehicles/PersonalInformationRow'
import { mapGetters } from 'vuex'

export default {
  name: 'PersonalInformation',
  components: {
    PersonalInformationRow
  },
  computed: {
    ...mapGetters([
      'name',
      'email',
      'sentri'
    ]),
    ...mapGetters('user', [
      'userIsCompanyType',
      'userIsNormalType'
    ]),
    cardTitle () {
      if (this.userIsCompanyType) {
        return 'INFORMACIÓN DE LA EMPRESA'
      }

      return 'INFORMACIÓN PERSONAL'
    },
    userNameLabel () {
      if (this.userIsCompanyType) {
        return 'Nombre del Representante Legal'
      }

      return 'Nombre'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/constants.scss';

#personal-information {
  border-radius: 2rem;
  width: 40%;
  height: 11rem;
  word-wrap: break-word;
}

.aside {
  border-radius: 2rem 0 0 2rem;
  background-color: $orange;
  height: 100%;
  width: 42%;
}

.icon {
  fill: $white;
  width: 5rem;
}

.label {
  color: $white;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 0.5rem;
  width: 60%;
}

.information {
  background-color: $white;
  border-radius: 0 2rem 2rem 0;
  width: 58%;
}

@media(max-width: 90rem) {
  #personal-information {
    height: 12rem;
  }

  .icon {
    width: 4.5rem;
  }

  .label {
    font-size: 1rem;
  }
}

@media screen and (max-width: 480px) {
  #personal-information {
    width: 100%;
    margin-bottom: 6%;
  }
  .label {
    width: 100%;
  }
}
</style>
